// Cloudflare Rocket Loader opt-out for webpack runtime chunk loading.
// Rocket Loader rewrites <script> tags and breaks dynamic imports
// (webpack inserts <script> tags at runtime for lazy-loaded chunks).
// Force every dynamically-created script tag to carry data-cfasync="false"
// so Cloudflare skips them. Must run BEFORE any other module is imported.
if (typeof document !== "undefined" && document.createElement) {
  const _origCreateElement = document.createElement.bind(document);
  document.createElement = function (tagName, options) {
    const el = _origCreateElement(tagName, options);
    try {
      if (typeof tagName === "string" && tagName.toLowerCase() === "script") {
        el.setAttribute("data-cfasync", "false");
      }
    } catch (_e) {
      // noop — never block boot
    }
    return el;
  };
}

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ChunkLoadErrorBoundary from "@/components/ChunkLoadErrorBoundary";
import { BUILD_VERSION } from "@/buildVersion";
import { forceClearStaleCachesOnce } from "@/utils/forceClearCache";

// Surface the build identifier on every boot so the Network panel
// and any operator tailing the JS console can confirm which build
// is live. The same value is rendered into a hidden ``data-build``
// attribute on the app shell and surfaced in the marketing footer.
// eslint-disable-next-line no-console
console.info("[UAVSimNet] build", BUILD_VERSION);

// Fire-and-forget — never blocks the first paint. The helper is
// gated on ``localStorage["uavsimnet:clearedFor"] === BUILD_VERSION``
// so it only does anything once per build per user-agent.
forceClearStaleCachesOnce();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ChunkLoadErrorBoundary>
      <App />
    </ChunkLoadErrorBoundary>
  </React.StrictMode>,
);
